import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import StripExhibitionist from './StripExhibitionist';
import ExhibitionistBox, {
  ExhibitionistBoxProps,
  ExhibitionistBoxType,
} from '../_partials/ExhibitionistBox';
import ExhibitionistEmptyState from '../_partials/ExhibitionistEmptyState';
import FavouritesLabel from '../_partials/FavouritesLabel';
import { withModuleData, WithModuleDataProps } from '../_hoc/withModuleData';
import { GallectionType } from '../../../../types/gallection';

import s from './StripExhibitionist.scss';

const enhance = compose(withModuleData, withTranslation());
class StripExhibitionistBox extends React.Component<
  ExhibitionistBoxProps & WithTranslation & WithModuleDataProps
> {
  render() {
    return (
      <ExhibitionistBox
        {...this.props}
        headerExtras={this.renderHeaderExtras}
        exhibitionistType={ExhibitionistBoxType.STRIP}
        emptyView={
          <ExhibitionistEmptyState
            moduleId={this.props.moduleId}
            view="small"
            className={s['empty-state']}
            exhibitionistType={ExhibitionistBoxType.STRIP}
          />
        }
      >
        {boxProps => <StripExhibitionist {...boxProps} />}
      </ExhibitionistBox>
    );
  }
  renderHeaderExtras = (exhibitionistProps: ExhibitionistBoxProps) => {
    const {
      moduleData: { sourceType },
    } = this.props;
    const { profileOwnerUser } = exhibitionistProps;
    if (sourceType === GallectionType.COLLECTION) {
      return <FavouritesLabel tooltipUser={profileOwnerUser} />;
    }
  };
}

export default enhance(StripExhibitionistBox) as React.ComponentType<{}>;
